import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useBatchOperationStore = defineStore('batchOperation', () => {
  const refreshTable = ref(0)
  return {
    refreshTable
  }
})
